import { Button, Dialog } from '@material-ui/core';
import { useEffect } from 'react';
import { useState } from 'react';

export function NoteModals({
    showModal = false,
    extraClass = '',
    heading = 'NOTE',
    info = '',
    proceedBtn = '',
    cancelBtn = '',
    proceedHref = '',
    mobileOrEmail = '',
    onCancel = () => { },
    ...props
}) {
    const [show, setShow] = useState<boolean>(showModal);

    useEffect(() => {
        setShow(showModal);
    }, [showModal]);

    const onProceed = () => {
        if (!!props.onProceed && typeof props.onProceed === 'function') {
            props.onProceed();
            return;
        }
        props.push(proceedHref);
    };

    return (
        <Dialog maxWidth={'sm'} open={show} aria-labelledby="note-modals">
            <div className={`note-modals ${extraClass}`}>
                <h3>{heading}</h3>
                <p>
                    {info} {mobileOrEmail}
                </p>
                <div className="note-modals-btns">
                    <Button className="customBtn" onClick={onProceed}>
                        {proceedBtn}
                    </Button>
                    {!!cancelBtn && (
                        <Button
                            className="customBtn cancelBtn"
                            onClick={() => {
                                setShow(!show);
                                onCancel();
                            }}
                        >
                            {cancelBtn}
                        </Button>
                    )}
                </div>
            </div>
        </Dialog>
    );
}
